import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RoomBooking } from '../models/room-booking/room-booking.model';
import { CourseInstance } from '../models/training/course-instance.model';
import { ExchangeApiService } from './exchange-api.service';

@Injectable()
export class SurveyTopicService {
  constructor(
    private apiService: ExchangeApiService,
  ) {
  }

  /**
   * Returns all survey topics that are unanswered by the current member
   */
  getNonAnsweredSurveyTopics(): Observable<CourseInstance[] | RoomBooking[]> {
    return this.apiService.get('members/me/non_answered_survey_topics');
  }
}
